import Hero from "../../components/Hero/Hero";
import About from "../../components/About/About";
import { useEffect } from "react";

const LandingPage = ({
  setSearchTerm,
  timeInterval,
  setTimeInterval,
  setAnalysis,
  analysis,
  postsAnalyzed,
  setPostsAnalyzed,
  subreddits,
}) => {
  useEffect(() => {
    document.title = `Eureka`;
    window.location.hash === "#_" && window.history.replaceState(null, "", "/");
    setAnalysis(false);
  }, [setAnalysis]);

  return (
    <>
      <Hero
        setSearchTerm={setSearchTerm}
        timeInterval={timeInterval}
        setTimeInterval={setTimeInterval}
        postsAnalyzed={postsAnalyzed}
        setPostsAnalyzed={setPostsAnalyzed}
        analysis={analysis}
        subreddits={subreddits}
      />
      <About />
    </>
  );
};

export default LandingPage;
